export {Notice as RoomNotice,type NoticeTone} from '@platform/ui/Notice';
import {noticeTone} from '@platform/ui/noticeCatalog';

export function purchaseNoticeTone(outcome:string){
 return outcome==='partial'?'warning':noticeTone('purchase.'+outcome,'warning');
}
